import booleanType from './boolean';

export default booleanType;
